import { gql } from "@apollo/client";

export const EMAIL_STOP = gql`
  mutation emailStop($id: Int!, $stopped: Boolean!) {
    emailStop(id: $id, stopped: $stopped) {
      id
      message
      isError
    }
  }
`;
